export default class StickyHeader {
    delegateNode = window;

    scrollEventName = 'scroll';

    isVisible = false;

    constructor(context, componentName) {
        this.name = componentName;
        this.context = context;

        this.bindListeners();
    }

    bindListeners() {
        this.delegateNode.addEventListener(this.scrollEventName, () => this.handleVisibility(), false);
        this.delegateNode.addEventListener('load', () => this.handleVisibility(), false);
    }

    handleVisibility() {
        const visibility = this.getScrollPosition > this.getAnchorPosition;

        if (visibility !== this.isVisible) {
            this.isVisible = visibility;
            this.context.classList.toggle('is-visible', visibility);
        }
    }

    get getScrollPosition() {
        return window.scrollY;
    }

    get getAnchorPosition() {
        return window.innerHeight;
    }
}
